<template lang="pug">
  v-dialog(v-model='dialogImportacionP4' scrollable persistent max-width='90%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline Carga de Contenedores
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Ordenes de Compra
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-data-table.elevation-6(:headers="headersOrdenes" :items='ordenes' locale='ES' :footer-props="{itemsPerPageText: 'Ordenes por página'}")
                      template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                      template(v-slot:item.action='{ item }' v-if="read === false")
                        v-tooltip(bottom='')
                          template(v-slot:activator='{ on }')
                            v-icon(fab dark color='success', v-on='on' @click='repartir(item)') mdi-plus
                          | Asignar
                      template(v-slot:no-data)
                        h2 Vacío
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Contenedores
              v-card-text
                v-row(dense)
                  table.tabla(border='0' width='80%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') Contenedor
                      td(align="center")
                        div
                          span.bold(style='color: black') Sello
                      td(align="center")
                        div
                          span.bold(style='color: black') Tipo
                      td(align="center")
                        div
                          span.bold(style='color: black') Capacidad
                      td(align="center")
                        div
                          span.bold(style='color: black') Piezas(und)
                      td(align="center")
                        div
                          span.bold(style='color: black') Peso(Kg)
                      td(align="center")
                        div
                          span.bold(style='color: black') CBM(ft³)
                      td(align="center")
                        div
                          span.bold(style='color: black') Total($)
                      td(align="center")
                        div
                          span.bold(style='color: black') Faltante(ft³)
                    tr(v-for='contenedor in contenedoresAux' align='center')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.contenedorOrd')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.selloOrd')
                      td.inputT
                        v-text-field.size(dense outlined readonly v-model='contenedor.tipoContenedorOrd')
                      td.inputT
                        v-text-field.size(dense outlined readonly v-model='contenedor.capacidadContenedorOrd' suffix="ft³")
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.piezasContenedorOrd')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.pesoContenedorOrd')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.piesCubicosContenedorOrd')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='contenedor.totalContenedorOrd')
                      td.inputT
                        v-text-field.size(dense outlined readonly v-model='contenedor.faltanteOrd')
                    tr
                      td
                      td
                      td
                      td.input3
                        b.letra TOTAL:
                      td.input
                        v-text-field.size(dense outlined readonly v-model='formP4.piezasGeneralContenedor')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='formP4.kilogramosGeneralContenedor')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='formP4.piesCubicosGeneralContenedor')
                      td.input
                        v-text-field.size(dense outlined readonly v-model='formP4.totalGeneralContenedor')
      v-card-actions
        v-btn(color='error' style='width: 10%' small dark @click='closePaso4')
          v-icon mdi-arrow-left-thick
          | Atras
        v-spacer
        //- v-btn(color='success' small dark @click='terminarGuardar()')
          v-icon mdi-content-save
          | Terminar y Guardar
        v-btn(v-if="read === false" color='success', small dark @click='save')
          v-icon mdi-content-save
          | Guardas
        v-btn(v-else color='success' style='width: 10%' small dark @click='closeTodo')
          v-icon mdi-close
          | Cerrar
    v-dialog(v-model='dialogCarga' scrollable persistent max-width='90%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          span.headline Productos de la Orden
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12')
                      v-data-table.elevation-6(:headers="headersPro" :items='ordenesProductosOrd' locale='ES' :search='search' :footer-props="{itemsPerPageText: 'Productos por página'}")
                        template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                        template(v-slot:item.contenedores='{ item }')
                          td
                            v-select(:items="contenedoresArray" v-model="item.contenedores")
                        template(v-slot:item.cantidadCargar='{ item }')
                          td
                            v-text-field(v-model="item.cantidadCargar" type="number", min="0")
                        template(v-slot:top='')
                          v-toolbar(flat color='primary' dark)
                            v-toolbar-title Productos
                            v-divider.mx-4(inset='' vertical='')
                            v-spacer
                            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line='' hide-details='' color='#e95d3d')
                            v-spacer
                            v-btn.ma-1(color='success' dark @click='cargarTodoBtn')
                              | Cargar Todo
                        template(v-slot:item.action='{ item }')
                          v-tooltip(bottom='')
                            template(v-slot:activator='{ on }')
                              v-icon.mr-2(@click='cargar(item)' color='success' v-on="on") mdi-package-variant
                            | Cargar al Contenedor
        v-card-actions
          v-btn(color='error', width='10%' small dark @click='closeCarga')
            v-icon mdi-arrow-left-thick
            | Atras
          v-btn(color='error' small dark @click='cancelarCarga')
            | Cancelar Carga
          v-spacer
          v-btn(color='success', small dark @click='closeCarga')
            | Continuar
            v-icon mdi-arrow-right-thick
    // para seleccionar el contenedor en caso de querer cargar todo
    v-dialog(v-model='dialogSelectConte' scrollable persistent max-width='30%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          span.headline Contenedor
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12')
                      v-select(dense outlined :items="contenedoresArray" v-model="contenedorAll" label='Seleccione el Contenedor')
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='cancelarAll')
            | Cancelar
          v-btn(color='success', small dark @click='cargarAll')
            v-icon mdi-content-save
            | Guardar
</template>

<script>
import Api from '@/services/methods'
import { EventBus } from '.././Events'
export default {
  props: ['dialogImportacionP4'],
  data: () => ({
    dialogCarga: false,
    dialogSelectConte: false,
    search: '',
    nroOrden: '',
    contenedorAll: '', 
    ordenes: [], // Carga de Contenedores: ordenes de compra
    ordenesAux: [],
    contenedoresArray: [], // Carga de Contenedores: Seleccionar los contenedores
    contenedoresAux: [], // Contenedores:para rellenar la tabla de contenedores
    ordenesProductosOrd: [], // Carga de Contenedores: datos de los productos
    historial: [], // para el resporte de los contenedores
    headersOrdenes: [
      { text: 'Nro. Orden', value: 'codigoOrd', align: 'center' },
      { text: 'Nro. de Piezas (und)', value: 'piezasOrd', align: 'center' },
      { text: 'Peso (Kg)', value: 'kilogramosOrd', align: 'center' },
      { text: 'Pies C. (ft³)', value: 'piesCubicosOrd', align: 'center' },
      { text: 'Total ($)', value: 'totalOrd', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headersPro: [
      { text: 'Código', value: 'co_art', align: 'center' },
      { text: 'Producto', value: 'art_des', align: 'center' },
      { text: 'Cantidad', value: 'cantidadRestante', align: 'center', sortable: false },
      { text: 'Contenedores', value: 'contenedores', align: 'center', sortable: false },
      { text: 'Cantidad a Carga', value: 'cantidadCargar', align: 'center', sortable: false },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    formP4: {},
    defaultFormP4: {},
    editedIndex: 0,
    read: false
  }),

  created () {
    EventBus.$on('dataImportacion3', data => {
      console.log('LLEGO A PASO 4', data)
      this.formP4 = data.formP3
      this.editedIndex = data.editedIndex
      this.read = data.read
      let bool = false
      if (!this.formP4.totalGeneralContenedor) {
        this.formP4.piezasGeneralContenedor = 0
        this.formP4.kilogramosGeneralContenedor = 0
        this.formP4.piesCubicosGeneralContenedor = 0
        this.formP4.metroCubicoGeneralContenedor = 0
        this.formP4.totalGeneralContenedor = 0
      } else {
        this.formP4.piezasGeneralContenedor = (this.formP4.piezasGeneralContenedor).toFixed(2)
        this.formP4.kilogramosGeneralContenedor = (this.formP4.kilogramosGeneralContenedor).toFixed(2)
        this.formP4.piesCubicosGeneralContenedor = (this.formP4.piesCubicosGeneralContenedor).toFixed(2)
        this.formP4.metroCubicoGeneralContenedor = (this.formP4.metroCubicoGeneralContenedor).toFixed(2)
        this.formP4.totalGeneralContenedor = (this.formP4.totalGeneralContenedor).toFixed(2)
      }
      data.formP3.importacion.map(dt => {
        if (this.ordenes.length > 0) {
          this.ordenes.map(or => {
            if (dt.codigoOrd === or.codigoOrd) {
              bool = true
            }
          })
          if (bool === false) {
            this.ordenes.push(dt)
          }
        } else {
          this.ordenes.push(dt)
        }
      })
      this.ordenes.map(or => {
        or.piezasOrd = (parseFloat(or.piezasOrd)).toFixed(2)
        or.piesCubicosOrd = (parseFloat(or.piesCubicosOrd)).toFixed(2)
        or.kilogramosOrd = (parseFloat(or.kilogramosOrd)).toFixed(2)
        or.totalOrd = (parseFloat(or.totalOrd)).toFixed(2)
      })
      this.initialize()
    })
  },

  methods: {
    initialize() {
      this.contenedoresAux = this.formP4.contenedores //objeto de contenedores
      this.contenedoresAux.map((cont) => {
        this.contenedoresArray.push(cont.contenedorOrd); // para el select del contenedor
      });
      for (let i = 0; i < this.formP4.importacion.length; i++) {
        this.ordenesAux.push({
          codigoOrd: this.formP4.importacion[i].codigoOrd,
          kilogramosOrd: this.formP4.importacion[i].kilogramosOrd,
          metroCubicoOrd: this.formP4.importacion[i].metroCubicoOrd,
          piesCubicosOrd: this.formP4.importacion[i].piesCubicosOrd,
          piezasOrd: this.formP4.importacion[i].piezasOrd,
          totalOrd: this.formP4.importacion[i].totalOrd,
        })
      }
    },
    
    repartir (item) {
      //console.log('ITEM REPARTIR', item)
      this.nroOrden = item.codigoOrd
      this.ordenesProductosOrd = item.productosOrd
      this.ordenesProductosOrd.map((or) => {
        or.cantidadCargar = 0
      });
      this.dialogCarga = true
    },

    // recordar revisar a profundidad las cargas
    cargar (item) {
      if (item.cantidadRestante > 0) {
        if ((item.contenedores && item.contenedores !== "") && (item.cantidadCargar && item.cantidadCargar > 0)) {
          item.cantidadCargar = parseFloat(item.cantidadCargar)
          item.cantidadRestante = parseFloat(item.cantidadRestante)
          if (item.cantidadCargar > item.cantidadRestante) {
            this.$swal.fire(
              'Oops... Ha ocurrido un error!',
              'Cantidad a cargar no puede ser mayor que la existencia del producto',
              'error'
            )
          } else {
            let _id = item._id // para mandar al metodo RESTAR
            let cantidadC = item.cantidadCargar
            
            let piezas = 0 // para aplicar las comparaciones y usar la variable "pies" en la validacion de capacidad del contenedor
            let peso = 0
            let pies = 0
            let total = 0
            for (let i = 0; i < this.contenedoresAux.length; i++) {
              if (this.contenedoresAux[i].contenedorOrd === item.contenedores) {
                if (!this.contenedoresAux[i].totalContenedorOrd || this.contenedoresAux[i].totalContenedorOrd === 0) {
                  piezas = item.cantidadCargar
                  peso = (item.cantidadCargar * item.peso)
                  pies = (item.cantidadCargar * item.volumen)
                  total = (item.cantidadCargar * item.cost_unit)

                  if (pies < this.contenedoresAux[i].capacidadContenedorOrd) {
                    this.contenedoresAux[i].piezasContenedorOrd = 0
                    this.contenedoresAux[i].pesoContenedorOrd = 0
                    this.contenedoresAux[i].piesCubicosContenedorOrd = 0
                    this.contenedoresAux[i].totalContenedorOrd = 0

                    this.contenedoresAux[i].piezasContenedorOrd = piezas
                    this.contenedoresAux[i].pesoContenedorOrd = peso
                    this.contenedoresAux[i].piesCubicosContenedorOrd = pies
                    this.contenedoresAux[i].totalContenedorOrd = total

                    this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)

                    this.contenedoresAux[i].faltanteOrd = (this.contenedoresAux[i].capacidadContenedorOrd - this.contenedoresAux[i].piesCubicosContenedorOrd).toFixed(2)
                  
                    this.cargarHistorial(_id, this.contenedoresAux[i].contenedorOrd)
                    this.restar(_id, cantidadC)
                    this.$swal.fire({
                      position: 'top-end',
                      icon: 'success',
                      title: 'Cantidad Agregada al contenedor',
                      width: '20%',
                      showConfirmButton: false,
                      timer: 1500
                    })
                  } else {
                    this.$swal.fire(
                      'Oops... Ha ocurrido un error',
                      'Ha sobrepasado la capacidad del contenedor',
                      'error'
                    )
                  }
                } else {
                  piezas = parseFloat(this.contenedoresAux[i].piezasContenedorOrd)
                  peso = parseFloat(this.contenedoresAux[i].pesoContenedorOrd)
                  pies = parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)
                  total = parseFloat(this.contenedoresAux[i].totalContenedorOrd)
                  
                  piezas += item.cantidadCargar
                  peso += (item.cantidadCargar * item.peso)
                  pies += (item.cantidadCargar * item.volumen)
                  total += (item.cantidadCargar * item.cost_unit)

                  //console.log('PIES 2', pies)
                  if (pies < this.contenedoresAux[i].capacidadContenedorOrd) {
                    this.contenedoresAux[i].piezasContenedorOrd = 0
                    this.contenedoresAux[i].pesoContenedorOrd = 0
                    this.contenedoresAux[i].piesCubicosContenedorOrd = 0
                    this.contenedoresAux[i].totalContenedorOrd = 0

                    this.contenedoresAux[i].piezasContenedorOrd = piezas
                    this.contenedoresAux[i].pesoContenedorOrd = peso
                    this.contenedoresAux[i].piesCubicosContenedorOrd = pies
                    this.contenedoresAux[i].totalContenedorOrd = total

                    this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)

                    this.contenedoresAux[i].faltanteOrd = (this.contenedoresAux[i].capacidadContenedorOrd - this.contenedoresAux[i].piesCubicosContenedorOrd).toFixed(2)

                    this.cargarHistorial(_id, this.contenedoresAux[i].contenedorOrd)
                    this.restar(_id, cantidadC)
                    this.$swal.fire({
                      position: 'top-end',
                      icon: 'success',
                      title: 'Cantidad Agregada al contenedor',
                      width: '20%',
                      showConfirmButton: false,
                      timer: 1500
                    })
                  } else {
                    this.$swal.fire(
                      'Oops... Ha ocurrido un error',
                      'Ha sobrepasado la capacidad del contenedor',
                      'error'
                    )
                    this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                    this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)
                  }
                }
              }
            } 
            this.formP4.piezasGeneralContenedor = 0
            this.formP4.kilogramosGeneralContenedor = 0
            this.formP4.piesCubicosGeneralContenedor = 0
            this.formP4.metroCubicoGeneralContenedor = 0
            this.formP4.totalGeneralContenedor = 0

            this.contenedoresAux.map(data => {
              if (
                  (data.piezasContenedorOrd && data.piezasContenedorOrd !== 0) && 
                  (data.pesoContenedorOrd && data.pesoContenedorOrd !== 0) &&
                  (data.piesCubicosContenedorOrd && data.piesCubicosContenedorOrd !== 0) &&
                  (data.totalContenedorOrd && data.totalContenedorOrd !== 0)
              ) 
              {
                this.formP4.piezasGeneralContenedor += parseFloat(data.piezasContenedorOrd)
                this.formP4.kilogramosGeneralContenedor += parseFloat(data.pesoContenedorOrd)
                this.formP4.piesCubicosGeneralContenedor += parseFloat(data.piesCubicosContenedorOrd)
                this.formP4.totalGeneralContenedor += parseFloat(data.totalContenedorOrd)
              }
            })

            this.formP4.piezasGeneralContenedor = parseFloat(this.formP4.piezasGeneralContenedor)
            this.formP4.kilogramosGeneralContenedor = parseFloat(this.formP4.kilogramosGeneralContenedor)
            this.formP4.piesCubicosGeneralContenedor = parseFloat(this.formP4.piesCubicosGeneralContenedor)
            this.formP4.metroCubicoGeneralContenedor = parseFloat((this.formP4.piesCubicosGeneralContenedor / 35.315))
            this.formP4.totalGeneralContenedor = parseFloat(this.formP4.totalGeneralContenedor)

            this.formP4.piezasGeneralContenedor = (this.formP4.piezasGeneralContenedor).toFixed(2)
            this.formP4.kilogramosGeneralContenedor = (this.formP4.kilogramosGeneralContenedor).toFixed(2)
            this.formP4.piesCubicosGeneralContenedor = (this.formP4.piesCubicosGeneralContenedor).toFixed(2)
            this.formP4.metroCubicoGeneralContenedor = (this.formP4.metroCubicoGeneralContenedor).toFixed(2)
            this.formP4.totalGeneralContenedor = (this.formP4.totalGeneralContenedor).toFixed(2)
          }
        } else {
          this.$swal.fire(
            'Oops... Ha ocurrido un error',
            'Debe introducir el Contenedor y la Cantidad a Cargar',
            'error'
          )
        }
      } else {
        this.$swal.fire(
          'Oops... Ha ocurrido un error',
          'Ha agotado el producto',
          'error'
        )
      }
    },

    cargarAll () {
      let piezas = 0
      let peso = 0
      let pies = 0
      let total = 0
      let cantidadVal = 0
      if (this.contenedorAll !== "") {
        for (let i = 0; i < this.contenedoresAux.length; i++) {
          if (this.contenedoresAux[i].contenedorOrd === this.contenedorAll) {
            if (!this.contenedoresAux[i].totalContenedorOrd || this.contenedoresAux[i].totalContenedorOrd === 0) {
              for (let k = 0; k < this.ordenesProductosOrd.length; k++) {
                if (this.ordenesProductosOrd[k].cantidadRestante > 0) {  
                  cantidadVal += this.ordenesProductosOrd[k].cantidadRestante
                  piezas += this.ordenesProductosOrd[k].cantidadCargar
                  peso += (this.ordenesProductosOrd[k].cantidadCargar * this.ordenesProductosOrd[k].peso)
                  pies += (this.ordenesProductosOrd[k].cantidadCargar * this.ordenesProductosOrd[k].volumen)
                  total += this.ordenesProductosOrd[k].reng_neto
                }
              }

              if (cantidadVal !== 0) {
                //console.log('PIES 3', pies)
                if (pies < this.contenedoresAux[i].capacidadContenedorOrd) {
                  this.contenedoresAux[i].piezasContenedorOrd = 0
                  this.contenedoresAux[i].pesoContenedorOrd = 0
                  this.contenedoresAux[i].piesCubicosContenedorOrd = 0
                  this.contenedoresAux[i].totalContenedorOrd = 0

                  this.contenedoresAux[i].piezasContenedorOrd = piezas
                  this.contenedoresAux[i].pesoContenedorOrd = peso
                  this.contenedoresAux[i].piesCubicosContenedorOrd = pies
                  this.contenedoresAux[i].totalContenedorOrd = total

                  this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)

                  this.contenedoresAux[i].faltanteOrd = (this.contenedoresAux[i].capacidadContenedorOrd - this.contenedoresAux[i].piesCubicosContenedorOrd).toFixed(2)

                  this.cargarHistorialAll(this.contenedorAll)
                  this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Contenedor Cargador',
                    width: '20%',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  this.contenedorAll = ""
                  this.dialogSelectConte = false
                  this.dialogCarga = false
                  this.restarAll()
                } else {
                  this.$swal.fire(
                    'Oops... Ha ocurrido un error',
                    'Ha sobrepasado la capacidad del contenedor',
                    'error'
                  )
                  this.contenedorAll = ""
                  this.dialogSelectConte = false
                }
              } else {
                this.$swal.fire(
                  'Oops... Ha ocurrido un error',
                  'Ha agotado los productos de esta orden',
                  'error'
                )
                this.contenedorAll = ""
                this.dialogSelectConte = false
              }
            } else {
              piezas = parseFloat(this.contenedoresAux[i].piezasContenedorOrd )
              peso = parseFloat(this.contenedoresAux[i].pesoContenedorOrd)
              pies = parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)
              total = parseFloat(this.contenedoresAux[i].totalContenedorOrd)

              for (let k = 0; k < this.ordenesProductosOrd.length; k++) {
                if (this.ordenesProductosOrd[k].cantidadRestante > 0) {
                  cantidadVal += this.ordenesProductosOrd[k].cantidadRestante
                  piezas += this.ordenesProductosOrd[k].cantidadCargar
                  peso += (this.ordenesProductosOrd[k].cantidadCargar * this.ordenesProductosOrd[k].peso)
                  pies += (this.ordenesProductosOrd[k].cantidadCargar * this.ordenesProductosOrd[k].volumen)
                  total += this.ordenesProductosOrd[k].reng_neto
                }
              }

              if (cantidadVal !== 0) {
                //console.log('PIES 4', pies)
                if (pies < this.contenedoresAux[i].capacidadContenedorOrd) {
                  this.contenedoresAux[i].piezasContenedorOrd = 0
                  this.contenedoresAux[i].pesoContenedorOrd = 0
                  this.contenedoresAux[i].piesCubicosContenedorOrd = 0
                  this.contenedoresAux[i].totalContenedorOrd = 0

                  this.contenedoresAux[i].piezasContenedorOrd = piezas
                  this.contenedoresAux[i].pesoContenedorOrd = peso
                  this.contenedoresAux[i].piesCubicosContenedorOrd = pies
                  this.contenedoresAux[i].totalContenedorOrd = total

                  this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)

                  this.contenedoresAux[i].faltanteOrd = (this.contenedoresAux[i].capacidadContenedorOrd - this.contenedoresAux[i].piesCubicosContenedorOrd).toFixed(2)

                  this.cargarHistorialAll(this.contenedorAll)
                  this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Contenedor Cargador',
                    width: '20%',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  this.contenedorAll = ""
                  this.dialogSelectConte = false
                  this.dialogCarga = false
                  this.restarAll()
                } else {
                  this.$swal.fire(
                    'Oops... Ha ocurrido un error',
                    'Ha sobrepasado la capacidad del contenedor',
                    'error'
                  )
                  this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                  this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)
                  this.contenedorAll = ""
                  this.dialogSelectConte = false
                }
              } else {
                this.$swal.fire(
                  'Oops... Ha ocurrido un error',
                  'Ha agotado los productos de esta orden',
                  'error'
                )
                this.contenedoresAux[i].piezasContenedorOrd = (parseFloat(this.contenedoresAux[i].piezasContenedorOrd)).toFixed(2)
                this.contenedoresAux[i].pesoContenedorOrd = (parseFloat(this.contenedoresAux[i].pesoContenedorOrd)).toFixed(2)
                this.contenedoresAux[i].piesCubicosContenedorOrd = (parseFloat(this.contenedoresAux[i].piesCubicosContenedorOrd)).toFixed(2)
                this.contenedoresAux[i].totalContenedorOrd = (parseFloat(this.contenedoresAux[i].totalContenedorOrd)).toFixed(2)
                this.contenedorAll = ""
                this.dialogSelectConte = false
              }
            }
          }
        }
        this.formP4.piezasGeneralContenedor = 0
        this.formP4.kilogramosGeneralContenedor = 0
        this.formP4.piesCubicosGeneralContenedor = 0
        this.formP4.metroCubicoGeneralContenedor = 0
        this.formP4.totalGeneralContenedor = 0
        this.contenedoresAux.map(data => {
          if (
              (data.piezasContenedorOrd && data.piezasContenedorOrd !== 0) && 
              (data.pesoContenedorOrd && data.pesoContenedorOrd !== 0) &&
              (data.piesCubicosContenedorOrd && data.piesCubicosContenedorOrd !== 0) &&
              (data.totalContenedorOrd && data.totalContenedorOrd !== 0)
          ) 
          {
            this.formP4.piezasGeneralContenedor += parseFloat(data.piezasContenedorOrd)
            this.formP4.kilogramosGeneralContenedor += parseFloat(data.pesoContenedorOrd)
            this.formP4.piesCubicosGeneralContenedor += parseFloat(data.piesCubicosContenedorOrd)
            this.formP4.totalGeneralContenedor += parseFloat(data.totalContenedorOrd)
          }
        })
        this.formP4.piezasGeneralContenedor = parseFloat(this.formP4.piezasGeneralContenedor)
        this.formP4.kilogramosGeneralContenedor = parseFloat(this.formP4.kilogramosGeneralContenedor)
        this.formP4.piesCubicosGeneralContenedor = parseFloat(this.formP4.piesCubicosGeneralContenedor)
        this.formP4.metroCubicoGeneralContenedor = parseFloat((this.formP4.piesCubicosGeneralContenedor / 35.315))
        this.formP4.totalGeneralContenedor = parseFloat(this.formP4.totalGeneralContenedor)

        this.formP4.piezasGeneralContenedor = (this.formP4.piezasGeneralContenedor).toFixed(2)
        this.formP4.kilogramosGeneralContenedor = (this.formP4.kilogramosGeneralContenedor).toFixed(2)
        this.formP4.piesCubicosGeneralContenedor = (this.formP4.piesCubicosGeneralContenedor).toFixed(2)
        this.formP4.metroCubicoGeneralContenedor = (this.formP4.metroCubicoGeneralContenedor).toFixed(2)
        this.formP4.totalGeneralContenedor = (this.formP4.totalGeneralContenedor).toFixed(2)
      } else {
        this.$swal({
          icon: 'error',
          text: 'Debe introducir el Contenedor'
        })
      }
    },

    cargarHistorial (_id, nombreContenedor) {
      var today = new Date()
      today = this.$moment(today).format('YYYY-MM-DD, HH:mm:ss')
      for (let k = 0; k < this.ordenes.length; k++) {
        if (this.ordenes[k].codigoOrd === this.nroOrden) {
          for (let j = 0; j < this.ordenes[k].productosOrd.length; j++) {
            if (this.ordenes[k].productosOrd[j]._id === _id) {
              if (this.historial.length > 0) {
                let ord = ''
                for (let i = 0; i < this.historial.length; i++) {
                  if (this.historial[i].contenedor === nombreContenedor) {
                    ord = {
                      _id: this.ordenes[k].productosOrd[j]._id,
                      codigoOrden: this.ordenes[k].codigoOrd,
                      facturaOrden: this.ordenes[k].facturaProvOrd,
                      codigoProductoOrden: this.ordenes[k].productosOrd[j].co_art,
                      cantPiezas: this.ordenes[k].productosOrd[j].cantidadCargar,
                      proveedorOrden: this.ordenes[k].proveedorOrd.nombre,
                      resumenOrden: this.ordenes[k].descripcionProdOrd,
                      totalOrden: (this.ordenes[k].productosOrd[j].cost_unit * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      piesOrden: (this.ordenes[k].productosOrd[j].volumen * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      pesoOrden: (this.ordenes[k].productosOrd[j].peso * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      fecha: today
                    }
                  }
                }
                if (ord) {
                  this.historial.map(hi => {
                    if (hi.contenedor === nombreContenedor) {
                      hi.ordenes.push(ord)
                    }
                  })
                } else {
                  this.historial.push({
                    contenedor: nombreContenedor,
                    ordenes: [{
                      _id: this.ordenes[k].productosOrd[j]._id,
                      codigoOrden: this.ordenes[k].codigoOrd,
                      facturaOrden: this.ordenes[k].facturaProvOrd,
                      codigoProductoOrden: this.ordenes[k].productosOrd[j].co_art,
                      cantPiezas: this.ordenes[k].productosOrd[j].cantidadCargar,
                      proveedorOrden: this.ordenes[k].proveedorOrd.nombre,
                      resumenOrden: this.ordenes[k].descripcionProdOrd,
                      totalOrden: (this.ordenes[k].productosOrd[j].cost_unit * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      piesOrden: (this.ordenes[k].productosOrd[j].volumen * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      pesoOrden: (this.ordenes[k].productosOrd[j].peso * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                      fecha: today
                    }]
                  })
                }
              } else {
                //console.log('ORDEN', this.ordenes[k])
                this.historial.push({
                  contenedor: nombreContenedor,
                  ordenes: [{
                    _id: this.ordenes[k].productosOrd[j]._id,
                    codigoOrden: this.ordenes[k].codigoOrd,
                    facturaOrden: this.ordenes[k].facturaProvOrd,
                    codigoProductoOrden: this.ordenes[k].productosOrd[j].co_art,
                    cantPiezas: this.ordenes[k].productosOrd[j].cantidadCargar,
                    proveedorOrden: this.ordenes[k].proveedorOrd.nombre,
                    resumenOrden: this.ordenes[k].descripcionProdOrd,
                    totalOrden: (this.ordenes[k].productosOrd[j].cost_unit * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                    piesOrden: (this.ordenes[k].productosOrd[j].volumen * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                    pesoOrden: (this.ordenes[k].productosOrd[j].peso * this.ordenes[k].productosOrd[j].cantidadCargar).toFixed(2),
                    fecha: today
                  }]
                })
              }
            }
          }
        }
      }
      console.log('HISTORIAL', this.historial)
    },

    cargarHistorialAll (nombreContenedor) {
      let ord = []
      let bool = false
      var today = new Date()
      today = this.$moment(today).format('YYYY-MM-DD, HH:mm:ss')
      for (let i = 0; i < this.ordenes.length; i++) {
        if (this.ordenes[i].codigoOrd === this.nroOrden) {
          for (let j = 0; j < this.ordenes[i].productosOrd.length; j++) {
            if (this.ordenes[i].productosOrd[j].cantidadRestante > 0) {
              ord.push({
                _id: this.ordenes[i].productosOrd[j]._id,
                codigoOrden: this.ordenes[i].codigoOrd,
                facturaOrden: this.ordenes[i].facturaProvOrd,
                codigoProductoOrden: this.ordenes[i].productosOrd[j].co_art,
                cantPiezas: this.ordenes[i].productosOrd[j].cantidadCargar,
                proveedorOrden: this.ordenes[i].proveedorOrd.nombre,
                resumenOrden: this.ordenes[i].descripcionProdOrd,
                totalOrden: parseFloat((this.ordenes[i].productosOrd[j].cost_unit * this.ordenes[i].productosOrd[j].cantidadCargar).toFixed(2)),
                piesOrden: parseFloat((this.ordenes[i].productosOrd[j].volumen * this.ordenes[i].productosOrd[j].cantidadCargar).toFixed(2)),
                pesoOrden: parseFloat((this.ordenes[i].productosOrd[j].peso * this.ordenes[i].productosOrd[j].cantidadCargar).toFixed(2)),
                fecha: today
              })
            }
          }
          if (this.historial.length > 0) {
            for (let k = 0; k < this.historial.length; k++) {
              if (nombreContenedor === this.historial[k].contenedor) {
                bool = true
                for (let m = 0; m < ord.length; m++) {
                  this.historial[k].ordenes.push(ord[m])
                }
              }
            }
            if (bool === false) {
              this.historial.push({
                contenedor: nombreContenedor,
                ordenes: ord
              })
            }
          } else {
            this.historial.push({
              contenedor: nombreContenedor,
              ordenes: ord
            })
          }
        }
      }
      console.log('HISTORIAL', this.historial)
    },

    restar (_id, cantidadC) {
      let Vcan = 0
      let kiloG = 0
      let piesC = 0
      let piezas = 0
      let total = 0
      for (let i = 0; i < this.ordenesProductosOrd.length; i++) {
        if (this.ordenesProductosOrd[i]._id === _id) {
          Vcan = this.ordenesProductosOrd[i].cantidadRestante - cantidadC

          this.ordenesProductosOrd[i].pesoTotal = this.ordenesProductosOrd[i].peso * Vcan
          this.ordenesProductosOrd[i].volumenTotal = this.ordenesProductosOrd[i].volumen * Vcan 
          this.ordenesProductosOrd[i].reng_neto = this.ordenesProductosOrd[i].cost_unit * Vcan
          this.ordenesProductosOrd[i].cantidadRestante = Vcan

          for (let k = 0; k < this.ordenes.length; k++) {
            if (this.ordenes[k].codigoOrd === this.nroOrden) {
              for (let j = 0; j < this.ordenes[k].productosOrd.length; j++) {
                if (this.ordenes[k].productosOrd[j]._id === this.ordenesProductosOrd[i]._id) {
                  this.ordenes[k].productosOrd[j] = this.ordenesProductosOrd[i]
                }
                kiloG += this.ordenes[k].productosOrd[j].pesoTotal
                piesC += this.ordenes[k].productosOrd[j].volumenTotal
                piezas += this.ordenes[k].productosOrd[j].cantidadRestante
                total += this.ordenes[k].productosOrd[j].reng_neto
              }
              this.ordenes[k].kilogramosOrd = 0
              this.ordenes[k].piesCubicosOrd = 0
              this.ordenes[k].metroCubicoOrd = 0
              this.ordenes[k].piezasOrd = 0
              this.ordenes[k].totalOrd = 0

              this.ordenes[k].kilogramosOrd = (kiloG).toFixed(2)
              this.ordenes[k].piesCubicosOrd = (piesC).toFixed(2)
              this.ordenes[k].metroCubicoOrd = ((piesC / 35.315)).toFixed(2)
              this.ordenes[k].piezasOrd = (piezas).toFixed(2)
              this.ordenes[k].totalOrd = (total).toFixed(2)
            }
          }
        }
      }
    },

    restarAll () {
      for (let k = 0; k < this.ordenes.length; k++) {
        if (this.ordenes[k].codigoOrd === this.nroOrden) {
          for (let j = 0; j < this.ordenes[k].productosOrd.length; j++) {
            this.ordenes[k].productosOrd[j].pesoTotal = 0
            this.ordenes[k].productosOrd[j].volumenTotal = 0
            this.ordenes[k].productosOrd[j].cantidadRestante = 0
            this.ordenes[k].productosOrd[j].reng_neto = 0
          }
          this.ordenes[k].kilogramosOrd = (0).toFixed(2)
          this.ordenes[k].piesCubicosOrd = (0).toFixed(2)
          this.ordenes[k].metroCubicoOrd = (0).toFixed(2)
          this.ordenes[k].piezasOrd = (0).toFixed(2)
          this.ordenes[k].totalOrd = (0).toFixed(2)
        }
      }
    },

    cargarTodoBtn () {
      for (let i = 0; i < this.ordenesProductosOrd.length; i++) {
        if (this.ordenesProductosOrd[i].cantidadRestante > 0) {
          this.ordenesProductosOrd[i].cantidadCargar = this.ordenesProductosOrd[i].cantidadRestante
        }
      }
      this.dialogSelectConte = true
    },

    cancelarAll () {
      this.ordenesProductosOrd.map(or => {
        or.contenedores = ''
        or.cantidadCargar = 0
      })
      this.contenedorAll = ""
      this.dialogSelectConte = false
    },

    cancelarCarga () {
      if (this.historial.length > 0 ) {
        this.ordenesProductosOrd.map(or => {
          or.contenedores = ''
          or.cantidadCargar = 0
        })

        // Variables para la suma
        let kilo = 0
        let pies = 0
        let metro = 0
        let piezas = 0
        let total = 0

        // Variables para la resta
        let kiloR = 0
        let piesR = 0
        let metroR = 0
        let piezasR = 0
        let totalR = 0

        // para reiniciar la orden de compra en caso que se desee cancelar la carga
        for (let k = 0; k < this.ordenes.length; k++) {
          if (this.ordenes[k].codigoOrd === this.nroOrden) {
            for (let j = 0; j < this.ordenes[k].productosOrd.length; j++) {
              if (this.ordenes[k].productosOrd[j].cantidadRestante !== this.ordenes[k].productosOrd[j].total_art) {

                piezasR = this.ordenes[k].productosOrd[j].cantidadRestante
                kiloR = this.ordenes[k].productosOrd[j].pesoTotal
                piesR = this.ordenes[k].productosOrd[j].volumenTotal
                metroR = (this.ordenes[k].productosOrd[j].volumenTotal / 35.315)
                totalR = this.ordenes[k].productosOrd[j].reng_neto

                this.ordenes[k].productosOrd[j].cantidadRestante = this.ordenes[k].productosOrd[j].total_art
                this.ordenes[k].productosOrd[j].pesoTotal = (this.ordenes[k].productosOrd[j].total_art * this.ordenes[k].productosOrd[j].peso)
                this.ordenes[k].productosOrd[j].reng_neto = (this.ordenes[k].productosOrd[j].total_art * this.ordenes[k].productosOrd[j].cost_unit)
                this.ordenes[k].productosOrd[j].volumenTotal = (this.ordenes[k].productosOrd[j].total_art * this.ordenes[k].productosOrd[j].volumen)

                kilo += (parseFloat(this.ordenes[k].productosOrd[j].pesoTotal) - parseFloat(kiloR))
                pies += (parseFloat(this.ordenes[k].productosOrd[j].volumenTotal) - parseFloat(piesR))
                metro += (parseFloat(this.ordenes[k].productosOrd[j].volumenTotal / 35.315) - parseFloat(metroR))
                piezas += (parseFloat(this.ordenes[k].productosOrd[j].total_art) - parseFloat(piezasR))
                total += (parseFloat(this.ordenes[k].productosOrd[j].reng_neto) - parseFloat(totalR))
              }
            }
            this.ordenes[k].kilogramosOrd = (parseFloat(this.ordenes[k].kilogramosOrd) + parseFloat(kilo)).toFixed(2)
            this.ordenes[k].piesCubicosOrd = (parseFloat(this.ordenes[k].piesCubicosOrd) + parseFloat(pies)).toFixed(2)
            this.ordenes[k].metroCubicoOrd = (parseFloat(this.ordenes[k].metroCubicoOrd) + parseFloat(metro)).toFixed(2)
            this.ordenes[k].piezasOrd = (parseFloat(this.ordenes[k].piezasOrd) + parseFloat(piezas)).toFixed(2)
            this.ordenes[k].totalOrd = (parseFloat(this.ordenes[k].totalOrd) + parseFloat(total)).toFixed(2)

            // sacar orden del historial
            for (let i = 0; i < this.historial.length; i++) {
              for (let j = 0; j < this.historial[i].ordenes.length; j++) {
                if (this.historial[i].ordenes[j].codigoOrden === this.nroOrden) {
                  this.historial[i].ordenes.splice(j, 1)
                  j--
                }
              }
              if (this.historial[i].ordenes.length === 0) {
                this.historial.splice(i, 1)
                i--
              }
            }
            //console.log('HISTORIAL', this.historial)
          }
        }
        // ultimos Totales de los contenedores
        this.formP4.piezasGeneralContenedor = 0
        this.formP4.kilogramosGeneralContenedor = 0
        this.formP4.piesCubicosGeneralContenedor = 0
        this.formP4.metroCubicoGeneralContenedor = 0
        this.formP4.totalGeneralContenedor = 0

        this.contenedoresAux.map(con => {
          con.piezasContenedorOrd = 0
          con.pesoContenedorOrd = 0
          con.piesCubicosContenedorOrd = 0
          con.totalContenedorOrd = 0
          con.faltanteOrd = con.capacidadContenedorOrd
        })

        // metiendo ordenes en contenedores
        if (this.historial.length > 0) {
          for (let k = 0; k < this.contenedoresAux.length; k++) {
            for (let i = 0; i < this.historial.length; i++) {
              if (this.historial[i].contenedor === this.contenedoresAux[k].contenedorOrd) {
                for (let j = 0; j < this.historial[i].ordenes.length; j++) {
                  this.contenedoresAux[k].piezasContenedorOrd = parseFloat(this.contenedoresAux[k].piezasContenedorOrd)
                  this.contenedoresAux[k].pesoContenedorOrd = parseFloat(this.contenedoresAux[k].pesoContenedorOrd)
                  this.contenedoresAux[k].piesCubicosContenedorOrd = parseFloat(this.contenedoresAux[k].piesCubicosContenedorOrd)
                  this.contenedoresAux[k].totalContenedorOrd = parseFloat(this.contenedoresAux[k].totalContenedorOrd)

                  this.contenedoresAux[k].piezasContenedorOrd += parseFloat(this.historial[i].ordenes[j].cantPiezas)
                  this.contenedoresAux[k].pesoContenedorOrd += parseFloat(this.historial[i].ordenes[j].pesoOrden)
                  this.contenedoresAux[k].piesCubicosContenedorOrd += parseFloat(this.historial[i].ordenes[j].piesOrden)
                  this.contenedoresAux[k].totalContenedorOrd += parseFloat(this.historial[i].ordenes[j].totalOrden)
                }
              }
            }
            this.contenedoresAux[k].piezasContenedorOrd = (this.contenedoresAux[k].piezasContenedorOrd).toFixed(2)
            this.contenedoresAux[k].pesoContenedorOrd = (this.contenedoresAux[k].pesoContenedorOrd).toFixed(2)
            this.contenedoresAux[k].piesCubicosContenedorOrd = (this.contenedoresAux[k].piesCubicosContenedorOrd).toFixed(2)
            this.contenedoresAux[k].totalContenedorOrd = (this.contenedoresAux[k].totalContenedorOrd).toFixed(2)
            this.contenedoresAux[k].faltanteOrd = (this.contenedoresAux[k].capacidadContenedorOrd - parseFloat(this.contenedoresAux[k].piesCubicosContenedorOrd)).toFixed(2)
          }

          // para acomodar ultimos Totales de los contenedores
          this.contenedoresAux.map(data => {
            this.formP4.piezasGeneralContenedor += parseFloat(data.piezasContenedorOrd)
            this.formP4.kilogramosGeneralContenedor += parseFloat(data.pesoContenedorOrd)
            this.formP4.piesCubicosGeneralContenedor += parseFloat(data.piesCubicosContenedorOrd)
            this.formP4.totalGeneralContenedor += parseFloat(data.totalContenedorOrd)
          })
          this.formP4.piezasGeneralContenedor = parseFloat(this.formP4.piezasGeneralContenedor)
          this.formP4.kilogramosGeneralContenedor = parseFloat(this.formP4.kilogramosGeneralContenedor)
          this.formP4.piesCubicosGeneralContenedor = parseFloat(this.formP4.piesCubicosGeneralContenedor)
          this.formP4.metroCubicoGeneralContenedor = parseFloat((this.formP4.piesCubicosGeneralContenedor / 35.315))
          this.formP4.totalGeneralContenedor = parseFloat(this.formP4.totalGeneralContenedor)

          this.formP4.piezasGeneralContenedor = (this.formP4.piezasGeneralContenedor).toFixed(2)
          this.formP4.kilogramosGeneralContenedor = (this.formP4.kilogramosGeneralContenedor).toFixed(2)
          this.formP4.piesCubicosGeneralContenedor = (this.formP4.piesCubicosGeneralContenedor).toFixed(2)
          this.formP4.metroCubicoGeneralContenedor = (this.formP4.metroCubicoGeneralContenedor).toFixed(2)
          this.formP4.totalGeneralContenedor = (this.formP4.totalGeneralContenedor).toFixed(2)
        }
        
        this.dialogCarga = false
        console.log('CARGA CANCELADA', this.historial)
      }
    },

    closeCarga () {
      this.ordenesProductosOrd.map(or => {
        or.contenedores = ''
        or.cantidadCargar = 0
      })
      this.dialogCarga = false
    },

    closePaso4 () {
      this.$emit('close')
    },

    closeTodo () {
      this.$emit('closeSave4')
    },

    validarContenedores () {
      if (this.formP4.totalGeneralContenedor === 0 && this.formP4.piezasGeneralContenedor  === 0) {
        this.$swal({
          icon: 'error',
          title: 'Error de carga!',
          text: 'Debe ingresar productos a los contenedores'
        })
        return true
      }
      return false
    },

    blanqueo () {
      this.ordenes = []
      this.contenedoresArray = []
      this.contenedoresAux = []
      this.historial = []
    },
    
    save () {
      if (!this.validarContenedores()) {
        this.formP4.contenedores.map((con) => {
          this.historial.map((his) => {
            if (con.contenedorOrd === his.contenedor) {
              con.historial = his.ordenes
            }
          });
        });
        this.formP4.importacion.map((impor) => {
          this.ordenesAux.map((ord) => {
            if (impor.codigoOrd === ord.codigoOrd) {
              impor.kilogramosOrd = ord.kilogramosOrd
              impor.metroCubicoOrd = ord.metroCubicoOrd
              impor.piesCubicosOrd = ord.piesCubicosOrd
              impor.piezasOrd = ord.piezasOrd
              impor.totalOrd = ord.totalOrd
            }
          });
        });
        console.log('FORM4', this.formP4)
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        const data = new FormData();
        Object.keys(this.formP4).map((key) => {
          if (Array.isArray(this.formP4[key])) {
            this.formP4[key].forEach((val) => {
              if (typeof val === "object" && val !== null) {
                return data.append(`${key}[]`, JSON.stringify(val));
              }
              return data.append(`${key}[]`, val);
            });
          } else if (
            typeof this.formP4[key] === "object" &&
            this.formP4[key] !== null
          ) {
            return data.append(key, JSON.stringify(this.formP4[key]));
          } else {
            return data.append(key, this.formP4[key]);
          }
        });
        if (this.formP4.archivo.imageFile) {
          data.append('imagen', this.formP4.archivo.imageFile)
        }
        if (this.editedIndex > -1) {
          Api.put('importacion', data)
            .then(response => {
              console.log(response.data)
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.blanqueo()
              this.$emit('closeSave4')
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          Api.post('importacion', data)
            .then(response => {
              console.log('GUARDO', response.data)
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.blanqueo()
              this.$emit('closeSave4')
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .input {
    padding: 0px 1px 0px 0px;
  }
  .inputT {
    padding: 0px 1px 0px 0px;
    width: 9%;
  }
  .input3 {
    padding: 0px 1px 20px 10px;
    text-align: center
  }
  .size {
    font-size: 14px;
  }
  .letra {
    color: rgb(0, 0, 0);
  }
  .tabla {
    margin: 5px
  }
</style>
